<template>
    <div class="page-background-container"></div>
</template>

<script>
    export default {
        name: "PageBackground"
    }
</script>

<style scoped lang="less">
    .page-background-container {
        position: fixed;
        z-index: -100;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: #F4F4F4;
    }
</style>
